import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import classes from './Header.module.css';

const Header = () => {
    const [openMenu, setOpenMenu] = useState(false);

    const menuToggleHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenMenu((isOpen) => !isOpen);
    };

    return (
        <header
            className={`${classes.header} ${classes.headerScrolled} ${
                openMenu ? classes.headerWhite : ''
            }`}
        >
            <div className="container">
                <nav className={classes.nav}>
                    <button
                        className={`${classes.navToggler} ${
                            openMenu ? classes.navTogglerOpen : ''
                        }`}
                        onClick={menuToggleHandler}
                        onTouchEnd={menuToggleHandler}
                        type="button"
                        aria-label="Toggle navigation menu"
                        aria-expanded={openMenu}
                        style={{ touchAction: 'manipulation' }}
                    >
                        <span className={classes.navTogglerTop}></span>
                        <span className={classes.navTogglerBottom}></span>
                    </button>

                    <div className={classes.navLogo}>
                        {/* The homepage is a static page (public/home), so leave the app to reach it. */}
                        <a href="/">
                            <img
                                src="/home/img/logo-blue.svg"
                                width="218"
                                height="58"
                                className={classes.navLogoImage}
                                alt="PrepBox"
                            />
                        </a>
                    </div>

                    <div
                        className={`${classes.navMenu} ${
                            openMenu ? classes.navMenuOpen : ''
                        }`}
                    >
                        <ul className={classes.navList}>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <a href="/">Home</a>
                            </li>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <NavLink to="k6program">K6-Program</NavLink>
                            </li>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <NavLink to="about">About</NavLink>
                            </li>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <NavLink to="lessons">Lessons</NavLink>
                            </li>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <NavLink to="workbooks">Workbooks</NavLink>
                            </li>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <NavLink to="blog">Blog</NavLink>
                            </li>
                            <li
                                className={classes.navListItem}
                                onClick={() => setOpenMenu(false)}
                            >
                                <NavLink to="schedule">Schedule</NavLink>
                            </li>

                            <li>
                                <Link to="/consultation" className={classes.ctaButton}>
                                    Book a Consultation
                                </Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
